import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../graphql/types.generated';
export type LinkAccountsMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateAccountConnectionsInput;
}>;

export type LinkAccountsMutationResult = { __typename?: 'Mutation' } & {
  createAccountConnections?: GraphQLTypes.Maybe<
    { __typename?: 'CreateAccountConnectionsPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const LinkAccountsDocument = gql`
  mutation linkAccounts($input: CreateAccountConnectionsInput!) {
    createAccountConnections(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
